__turbopack_context__.v({
  "article": "vKakBG_article",
  "button": "vKakBG_button",
  "textContainer": "vKakBG_textContainer",
  "title": "vKakBG_title",
});
